/* eslint-disable no-restricted-syntax */
import { MedicalTranscriptResultStream } from "@aws-sdk/client-transcribe-streaming";
import _ from "lodash";

export class AWSTranscribeResultBuilder {
  private completeTokens: string[] = []
  private partialToken?: string

  hasAnyCompletion() {
    return this.completeTokens.length > 0
  }

  isFinal() {
    return this.partialToken === undefined
  }

  hasPartial() {
    return !!this.partialToken
  }

  accept(stream: MedicalTranscriptResultStream) {
    const transcript = stream?.TranscriptEvent?.Transcript
    if (!transcript) { return }

    const result = transcript.Results?.[0]
    const isPartial = !!result?.IsPartial
    const value = result?.Alternatives?.[0]?.Transcript
    if (!value) { return }

    if (!isPartial) {
      this.completeTokens.push(value)
      this.partialToken = undefined
    } else {
      this.partialToken = value
    }

  }

  getCurrentTextValue() {
    return _.join(this.completeTokens, ' ') + (this.partialToken ? ` ${this.partialToken}` : '')
  }

  finalizePartial() {
    if (this.partialToken) {
      this.completeTokens.push(this.partialToken)
      this.partialToken = undefined
    }
  }

  reset() {
    this.completeTokens = []
    this.partialToken = undefined
  }

}